import NavBar from './navBar/navBar';
import HeroBody from './heroBody/heroBody';
import { useLocation } from 'react-router-dom';
import { useState } from 'react';

const Hero = () => {
  const location = useLocation();
  const validPaths = ['Home', 'About', 'Projects', 'Services', 'Contacts'];
  const [activeLink, setActiveLink] = useState(location.pathname.substring(1) || 'Home');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState<boolean>(false);

  return (
    <div className={`hero ${validPaths.includes(activeLink) ? 'hero-bg' : ''}`}>
      <NavBar activeLink={activeLink} setActiveLink={setActiveLink} isMobileMenuOpen={isMobileMenuOpen} setIsMobileMenuOpen={setIsMobileMenuOpen} />
      <HeroBody activeLink={activeLink} isMobileMenuOpen={isMobileMenuOpen} />
    </div>
  );
};

export default Hero;
